import { config } from 'config'

export const getStatsigEnv = () => config.env
